<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
    v-if="Object.keys(userData).length"
  >
    <template #button-content>
      <b-img
        :src="
          userData.avatar || userData.logo
            ? userData.avatar || userData.logo
            : userData.gender == 'MALE'
            ? require('@/assets/images/fxlegends/172625_male_user_icon.svg')
            : userData.gender == 'FEMALE'
            ? require('@/assets/images/fxlegends/172621_user_female_icon.svg')
            : errorImage
        "
        @error="setAltImg"
        style="border: 2px solid #fbad25 !important"
        alt="profile photo"
        class="rounded-avatar p-25"
        width="40"
        height="40"
      />
      <div class="d-sm-flex d-none user-nav ml-50">
        <p class="user-name font-weight-bolder mb-0">
          <template v-if="userData.type == 'user' || userData.type == 'admin'">
            {{ userData.first_name + " " + userData.last_name }}
          </template>
          <template v-else>
            {{ userData.name }}
          </template>
        </p>
        <span class="user-status">{{ userData.type }}</span>
      </div>
    </template>

    <b-dropdown-item
      v-if="!$route.fullPath.includes('partner-registration')"
      :to="{
        name:
          userData.type == 'partner'
            ? 'partners-edit-profile'
            : 'users-edit-profile',
      }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="EditIcon" class="mr-50" />
      <span>Edit profile</span>
    </b-dropdown-item>
    <b-dropdown-item
      v-if="!$route.fullPath.includes('partner-registration')"
      :to="{
        name:
          userData.type == 'partner' ? 'partner-dashboard' : 'user-dashboard',
      }"
      link-class="d-flex align-items-center"
    >
      <feather-icon size="16" icon="HomeIcon" class="mr-50" />
      <span>Dashboard</span>
    </b-dropdown-item>
    <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
      <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
      <span>Logout</span>
    </b-dropdown-item></b-nav-item-dropdown
  >
</template>

<script>
import {
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BImg,
} from "bootstrap-vue";
import { avatarText } from "@core/utils/filter";

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BImg,
  },
  data() {
    return {
      avatarText,
    };
  },
  computed: {
    userData() {
      return (
        this.$store.state.auth.userData ||
        JSON.parse(localStorage.getItem("userData"))
      );
    },
  },
  methods: {
    async logout() {
      // Remove userData from localStorage
      try {
        const { data } = await this.$http.post("auth/user/logout");
        await localStorage.removeItem("userData");
        await this.$store.dispatch("auth/setUserData", {});
        await localStorage.removeItem("token");
        this.$http.defaults.headers.common["Authorization"] = await ``;
        // Redirect to login page
        this.$router.push({ name: "auth-user-login" });
      } catch (err) {}
    },
  },
};
</script>
